export type NavLink = {
  title: string
  label?: string
  icon: any
  Component?: React.ComponentType
  onClick?: () => void
  variant?: 'default' | 'ghost'
  id: string
}

export interface NavProps {
  isCollapsed: boolean
  links: NavLink[]
  resize?: (size: number) => void
  defaultActive?: string
}

export const globalAudioId = 'global-audio'

export type JsonResponse<T> = {
  success: boolean
  code: number
  response: T
}

export type ApiResponse<T = string> = {
  data: JsonResponse<T>
}

export type ToastType =
  | 'noAuth'
  | 'draft'
  | 'blocked'
  | 'pending'
  | 'successToResetPassword'
  | 'successToVerifyEmail'

export type GeneralInputType = 'text' | 'email' | 'password' | 'tel'

export interface ButtonContent {
  text: string
  icon?: React.ReactElement | undefined
}

export interface Option {
  [key: string]: string
}

export enum SelectTarget {
  Ticker = 'ticker',
  Document = 'document',
}

export const SelectTargetLabel: { [key in SelectTarget]: string } = {
  [SelectTarget.Ticker]: 'Ticker',
  [SelectTarget.Document]: 'Document',
}

export enum ModalType {
  Submit = 'submit',
  Warning = 'warning',
  Alert = 'alert',
}

export interface ModalProps {
  title: string
  body: string | React.ReactNode
  onSubmit?: () => void
  submitText?: string
  cancelText?: string
  type: ModalType
  isLoading?: boolean
  // Blocks submit without claiming the modal is loading: isLoading also disables
  // Cancel and relabels submit to "Loading...", so it can't double as a
  // precondition gate (e.g. "nothing is eligible", "preview not fetched yet").
  submitDisabled?: boolean
  // A second choice placed between Cancel and the submit button, outlined in red (e.g. Reject
  // beside Approve). Its own isLoading relabels it and locks the other buttons like isLoading does.
  secondaryAction?: {
    text: string
    onClick: () => void
    isLoading?: boolean
    disabled?: boolean
  }
}

export type ComponentLibraryMenus = 'Button' | 'Icons' | 'Date Picker'

export type DatePickerMode = 'single' | 'range'

export enum BucketName {
  Workflow = 'workflow',
  Embed = 'embed',
}

export const BucketNameObject: Record<string, string> = {
  [BucketName.Workflow]: process.env.LINQ_BUCKET_WORKFLOW || 'alpha-workflow-automation',
  [BucketName.Embed]: process.env.LINQ_BUCKET_DOCUMENTS || 'linq-vertex-documents',
}

export enum PanelState {
  Close = 'close',
  HalfOpen = 'half_open',
  FullOpen = 'full_open',
}

export interface SelectOption {
  id: string
  labelText: string
  [key: string]: any
}

export enum ShareChannel {
  Link = 'link',
  Email = 'email',
  Facebook = 'facebook',
  Telegram = 'telegram',
  Twitter = 'twitter',
  Linkedin = 'linkedin',
  Whatsapp = 'whatsapp',
  LinqAlpha = 'linqalpha',
}
